(function(){
    angular
        .module('appback')
        .directive('ngCkeditor', ckeditor);

        ckeditor.$inject = ['ResultadosService','$timeout'];
        function ckeditor(ResultadosService,$timeout){
            return {
            require: 'ngModel',
            scope: {
                ngModel:"=",
              autocomplete: "=",
              centro:"="
            },
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    var value = $attrs.value;
                    var $element = $(element);
                    ////console.log(scope);
                    var name = $element.attr("id");
                    var editor

                    function updateModel() {
                        //console.log("UPDATE CKEDITOR");
                        ngModel.$setViewValue(ck.getData());
                        /*$timeout(function(){

                        ck.fire('change');
                        })*/

                        //scope.$apply(function() {
                          //console.log(ck);
                          //console.log(ck.getData());
                            //ngModel.$setViewValue(ck.getData());
                        //});
                    }

                    //console.log(scope);
                    if(typeof(scope.autocomplete) != 'undefined' && scope.autocomplete.node=='comentarios'){
                        //console.log("autocomplete");
                        var PLACEHOLDERS = [{
                            id: 1,
                            name: 'address',
                            title: 'Address',
                            description: 'Customer Support correspondence address.'
                        },{
                            id: 2,
                            name: 'address dos',
                            title: 'Address dos',
                            description: 'Customer Support correspondence address.'
                        }];
                        CKEDITOR.addCss('span > .cke_placeholder { background-color: #ffeec2; } .cke_autocomplete_panel{width:600px}');

                         var ck = CKEDITOR.replace(name, {
                          enterMode : CKEDITOR.ENTER_P,
                          extraPlugins: 'autocomplete,textmatch,placeholder',
                          toolbar : 'Basic',
                          on: {
                            instanceReady: function(evt) {
                              var itemTemplate = '<li data-id="{id}">' +
                                '<div><strong class="item-title">#{text}</strong></div>' +
                                '<div><i>{categoria}</i></div>' +
                                '</li>',
                                outputTemplate = '{text}';

                              var autocomplete = new CKEDITOR.plugins.autocomplete(evt.editor, {
                                textTestCallback: textTestCallback,
                                dataCallback: dataCallback,
                                itemTemplate: itemTemplate,
                                outputTemplate: outputTemplate
                              });

                              // Override default getHtmlToInsert to enable rich content output.
                              autocomplete.getHtmlToInsert = function(item) {
                                return this.outputTemplate.output(item);
                              }
                            }
                          }
                        });

                        function textTestCallback(range) {
                          if (!range.collapsed) {
                            return null;
                          }

                          return CKEDITOR.plugins.textMatch.match(range, matchCallback);
                        }

                        function matchCallback(text, offset) {
                          var pattern = /\#{1}([A-z0-9 _]|\])*$/,
                            match = text.slice(0, offset)
                            .match(pattern);
                           //console.log(match);
                          if (!match) {
                            return null;
                          }

                          return {
                            start: match.index,
                            end: offset
                          };
                        }
                        var peticion = "";
                        function dataCallback(matchInfo, callbackD) {
                            //$.get("/backend/resultadopeticion/getcomentarios",{ text:matchInfo.query })
                            if(peticion){
                                //console.log("cancelar");
                                //console.log(peticion);
                                peticion.cancel("User cancelled");
                            }
                            peticion = ResultadosService.getComentarios(matchInfo.query,scope.autocomplete.categoria,scope.centro.idioma_code,false,false,0,function(result){
                                var dataItems = result.resultados.filter(function(item) {
                                  var itemName = item.text.toLowerCase();
                                  return itemName.indexOf(matchInfo.query.replace("#","").toLowerCase()) != -1;
                                });
                                //console.log(dataItems);
                                callbackD(dataItems);
                            });
                            //var data = PLACEHOLDERS.filter(function(item) {
                            //  var itemName = "#"+item.name.toLowerCase();
                            //  return itemName.indexOf(matchInfo.query.toLowerCase()) != -1;
                            //});
                            ////console.log(data);
                            //callback(data);
                      
                        }
                        /*CKEDITOR.replace(name,{
                            enterMode : CKEDITOR.ENTER_P,
                            extraPlugins:'mentions',
                            toolbar : 'Basic', 
                            mentions: [ {
                                feed: '/backend/resultadopeticion/getcomentarios?text={encodedQuery}',
                                marker: '#',
                                itemTemplate: '<li data-id="{categoria}">' +
                                    '<strong class="username">{text}</strong>' +
                                    '<span class="fullname">{categoria}</span>' +
                                    '</li>',
                                outputTemplate: '{text}',
          
                            } ]
                            //mentions: [ { feed: ['Anna', 'Thomas', 'John'], minChars: 0 } ]

                            
                        })*/
   
                    }else{
                         var ck = CKEDITOR.replace(name,{
                            enterMode : CKEDITOR.ENTER_P,
                            toolbar : 'Basic', /* this does the magic */
                        })

                        
                    }

                    ck.on( 'instanceReady', function( ev ) {
                        editor = ev.editor;

                        scope.$watch(function() {
                            return element.attr('readonly'); 
                        }, function(newValue){
                            if(newValue){
                                editor.setReadOnly( true );
                            }else{
                                editor.setReadOnly( false );
                            }
                        });
                    });
                     ngModel.$render = function () {
                        var newValue = ngModel.$viewValue;
                        ck.setData(newValue);
                        //console.log(newValue)
                    };

                    /*scope.$watch(scope.ngModel,function () {
                        console.log("WATCH");
                        //return ngModel.$modelValue;
                    }, function(newValue) {
                        console.log("WATCH2");
                        ck.setData(newValue);
                    });*/
                
					          ck.on('change', updateModel);
                    ck.on('key', updateModel);
                    ck.on('dataReady', updateModel);
                    ck.on( 'mode', function() {
                        // Debugger.log('ckeditor mode change: '+ this.mode);
                        if ( this.mode == 'source' ) {
                            var editable = ck.editable();
                            editable.attachListener( editable, 'input', function() {
                                // Debugger.log('ckeditor source input change');
                                 ck.fire('change');
                            } );
                        }
                    } );
                });
            }
          }
      }
})();